import React from 'react';

var Notification = function Notification(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.998 4.587c2.5.454 4.4 2.62 4.4 5.226 0 2.355.446 4.171 1.179 5.524.415.767.804 1.199 1.016 1.356.775.574.37 1.803-.595 1.803h-3.032a4 4 0 0 1-7.936 0H5.002c-.968 0-1.371-1.237-.59-1.807.217-.158.613-.591 1.034-1.357.743-1.352 1.197-3.167 1.197-5.519 0-2.591 1.877-4.746 4.355-5.218V3a1 1 0 1 1 2 0v1.587zm.937 13.909h-3.873a2 2 0 0 0 3.873 0zm2.884-2.207c-.893-1.65-1.421-3.793-1.421-6.476 0-1.826-1.51-3.314-3.378-3.314S8.643 7.987 8.643 9.813c0 2.685-.537 4.831-1.445 6.482a9.81 9.81 0 0 1-.113.202h9.849a9.836 9.836 0 0 1-.115-.208z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Notification.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { Notification as icon };
export default iconHandler(Notification);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/Notification.js
// module id = 617
// module chunks = 0